import type { Moment } from 'moment-timezone'

export const getIsoWithoutTheZ = (date: Moment) => {
  return date.format('YYYY-MM-DDTHH:mm:ss.SSS')
}
